// Capture UTM params from the URL and persist for the session so any form
// submitted later can attribute the visitor's origin (Instagram, email, etc.)
const KEY = "ce_utm";

export function captureUtm() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const utm = {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_content: params.get("utm_content"),
    utm_term: params.get("utm_term"),
  };
  const hasAny = Object.values(utm).some(Boolean);
  if (hasAny) sessionStorage.setItem(KEY, JSON.stringify(utm));
}

export function getUtm() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

// Returns a compact human-readable source string, e.g. "instagram / bio / launch-tease"
export function getUtmSource() {
  const u = getUtm();
  if (!u.utm_source) return null;
  return [u.utm_source, u.utm_medium, u.utm_campaign].filter(Boolean).join(" / ");
}
